// 意大利语(Italian)
export default {
  coinSpecialOffer: "Offerta speciale ricarica Moneta HT",
  buySomeAndGetExtra: "Acquistane un po' e avrai un extra!",
  balance: "Bilancio",
  coins: "{number} monete",
  coin: "{number} moneta",
  extraCoins: "{number} monete extra",
  continue: "Continua",
  byToppingUpYouAgree: "Effettuando la ricarica accetti l'accordo",
  topUpAgreement: "[Accordo di ricarica]",
  htCoin: "Moneta HT",
  scanCodeToLog: "Scansiona il codice per accedere",
  bindYourHelloTalkAccount:
    "Usa l'app HelloTalk per scansionare il codice e accedere. Associa il tuo account HelloTalk e ricarica.",
  itemSelection: "Selezione articolo",
  paymentAmount: "Ammontare",
  topUpSuccessful: "Ricarica riuscita👏",
  totalCoinsNumber:
    "Hai aggiunto con successo {numberone} monete e ricevuto {numbertwo} monete extra, per un totale di {numberall} monete.",
  ok: "OK",
  copyLinkToPay:
    "Copia il link e aprilo con l'app HelloTalk per completare il pagamento.",
  paymentFailed: "Pagamento fallito",
  creditCardPay: "Paga con PayPal o carta di credito",
  creditCard: "Carta di credito",
};
